var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15694 7.71089L1.49994 13.3679L0.0859375 11.9539L5.03594 7.00389L0.0859375 2.05389L1.49994 0.639893L7.15694 6.29689C7.34441 6.48442 7.44972 6.73873 7.44972 7.00389C7.44972 7.26906 7.34441 7.52337 7.15694 7.71089Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBr);
export default __webpack_public_path__ + "static/media/chevron-br.53d254b399cc31245256cfcd0b2e12ad.svg";
export { ForwardRef as ReactComponent };